// src/services/routeeService.jsx
import axiosInstance from './axiosConfig';

const routeeService = {
  // GET: /api/v1/routes?page=1&limit=10
  getAll: async (page = 1, limit = 10) => {
    const response = await axiosInstance.get(`/routes?page=${page}&limit=${limit}`);
    return response.data.data ?? response.data;
  },

  // POST: /api/v1/routes/create
  // { routes: [ { name, isActive }, ... ] }
  create: async (payload) => {
    const response = await axiosInstance.post('/routes/create', payload);
    return response.data;
  },

  // PUT: /api/v1/routes/edit/:id
  // { name: "L-10", isActive: true }
  update: async (id, data) => {
    const response = await axiosInstance.put(`/routes/edit/${id}`, data);
    return response.data;
  },

  // DELETE: /api/v1/delete/:id
  delete: async (id) => {
    const response = await axiosInstance.delete(`/delete/${id}`);
    return response.data;
  },
};

export default routeeService;
